import React from "react";

import { Container,Navbar, Nav, Button} from "react-bootstrap";
const logoSrc = "/logo2.png";
function MainNavigation()
{
  return ( 
    <Navbar expand="lg" bg="white" className="shadow-sm py-3">
        <Container>
          <Navbar.Brand href="#" className="d-flex align-items-center gap-2">
            <img src={logoSrc} alt="Innoish" className="logo-img" />
            {/* <span className="brand-text">Innoish Technologies</span> */}
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="main-nav" />
          <Navbar.Collapse id="main-nav" className="justify-content-end">
            <Nav className="align-items-center">
              <Nav.Link href="#solutions">Solutions</Nav.Link>
              <Nav.Link href="#about">About</Nav.Link>
              <Nav.Link href="#contact">Contact</Nav.Link>
              <Button href="#demo" className="btn-primary-gradient ms-3">Request Demo</Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
    </Navbar>
  );
};

export default MainNavigation;
